import {
  Button,
  HeadTitle,
  MenuBottomsheet,
  SelectField,
  Spacer,
  TextField,
  Tmd14,
} from 'oui';
import { SideBox, Height60, FloatingBox } from '../../etc/LBox/LBox';
import { useMtgConditions } from '../../../application/bloc/useMtgConditions';
import { useMtgIncome } from '../../../application/bloc/useMtgIncome';
import { currencyKR, mtgJoinDtDate } from '../../../application/helper/filter';
import moment from 'moment';
import { ClkBtnSubEventNm } from '../../../application/hooks/useBeacon';

export const MtgIncome = () => {
  const {
    navigateNextStep,
    selectSheet,
    openSelectSheet,
    mortgageInfo,
    onChangeWrappingInput,
    onChangeInput,
    saveInputInfoTemp,
  } = useMtgConditions();
  const {
    isActive,
    openDtWarning,
    validateJobDate,
    sendBeaconClkBtnOption,
    onBlurOpenDt,
    sendBeaconClkBtn,
  } = useMtgIncome();

  const onClickButton = () => {
    sendBeaconClkBtn(ClkBtnSubEventNm.Next, {
      annual_income: mortgageInfo.salaryAmt ?? '',
    });

    void saveInputInfoTemp();
    navigateNextStep('PUSH');
  };

  const onClickSelectField = (type: string) => {
    openSelectSheet(type);
  };

  const onChangeMenuBottomsheet = (e: any) => {
    onChangeWrappingInput({
      key: selectSheet.stateNm,
      text: e.text,
      value: e.value,
    });

    if (selectSheet.title) {
      sendBeaconClkBtnOption({
        btmsheet_name: selectSheet.title,
        option_name: e.text,
        before_option_name: mortgageInfo[selectSheet.stateNm]?.text ?? '',
      });
    }
  };

  const Space = () => (
    <>
      <Spacer size="md" />
    </>
  );

  return (
    <>
      <HeadTitle textTitle={'결혼 여부와 직업, 소득 정보를\n 입력해 주세요'} />
      <Spacer size={'xs'} />
      <SideBox>
        <SelectField
          inputTitle="결혼 여부"
          value={mortgageInfo.marriageCd.text ?? ''}
          placeholder={'결혼 여부'}
          onChangeSelectField={() => {}}
          onClickSelectField={() => onClickSelectField('C047')}
        />
        <Space />
        <SelectField
          inputTitle="직업"
          value={mortgageInfo.jobType.text ?? ''}
          placeholder={'직업'}
          onChangeSelectField={() => {}}
          onClickSelectField={() => onClickSelectField('C001')}
        />
        {mortgageInfo.jobType.value === '04' && (
          <>
            <Space />
            <TextField
              inputTitle="개업일자"
              placeholder={'예.20230101'}
              value={mortgageInfo.openDt.text ?? ''}
              state={mortgageInfo.openDt.text ? 'focused' : 'enabled'}
              inputMode={'numeric'}
              id={'txtOpenDt'}
              warning={openDtWarning}
              onBlur={onBlurOpenDt}
              onChangeTextInput={(value) => {
                if (validateJobDate(value)) {
                  onChangeWrappingInput({
                    key: 'openDt',
                    text: mtgJoinDtDate(value, '.'),
                    value,
                  });
                }
              }}
              onClickTextField={() => {}}
            />
          </>
        )}
        <Space />
        <TextField
          inputTitle={
            !mortgageInfo.marriageCd?.value ||
            mortgageInfo.marriageCd?.value === '10'
              ? '연소득(세전)'
              : '부부 합산소득(세전)'
          }
          placeholder={'0'}
          state={'enabled'}
          id={'txtSalaryAmt'}
          adornment={'만 원'}
          value={mortgageInfo.salaryAmt ?? ''}
          inputMode={'numeric'}
          helperText={currencyKR(mortgageInfo?.salaryAmt * 10000)}
          onChangeTextInput={(value) => {
            const amt = value.replace(/,/g, '');
            if (amt.length > 6) return;
            onChangeInput({ key: 'salaryAmt', value });
          }}
        />
      </SideBox>
      <Height60 />
      <Spacer size="xs" />
      <FloatingBox>
        <Button
          flexible={true}
          configuration={'contained'}
          isDisabled={!isActive}
          state={isActive ? 'enabled' : 'disabled'}
          children={'다음'}
          onClick={onClickButton}
        />
      </FloatingBox>
      <MenuBottomsheet
        selectType="instant"
        isOpenBottomSheet={selectSheet.open}
        title={selectSheet.title}
        subTitle={selectSheet.subTitle}
        items={selectSheet.items}
        onClickMenuItem={(e: any) => {
          onChangeMenuBottomsheet(e);
          selectSheet.onClose();
        }}
        onClickCloseMenuBottomsheet={selectSheet.onClose}
        defaultValue={mortgageInfo[selectSheet.stateNm]}
      />
    </>
  );
};
